import { BreezeService } from '@common/services/breeze.service';
import { DialogService } from '@common/services/dialog.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
import * as i2 from "@common/services/breeze.service";
import * as i3 from "@common/services/dialog.service";
import * as i4 from "@angular/common";
import * as i5 from "@angular/router";
import * as i6 from "@fortawesome/angular-fontawesome";
import * as i7 from "@ngx-translate/core";
import * as i8 from "@progress/kendo-angular-grid";
import * as i9 from "@progress/kendo-angular-buttons";
import * as i10 from "../app-grid/app-grid.component";
import * as i11 from "../bool/bool.component";
import * as i12 from "../flag-icon.component";
import * as i13 from "../../pipes/codelist.pipe";
function VesselRevisionChangesModalComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const row_r25 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", row_r25.label, " ");
  }
}
const _c0 = function (a2) {
  return ["/vessel-revision", "view", a2];
};
function VesselRevisionChangesModalComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 37);
    i0.ɵɵelement(1, "fa-icon", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r26 = ctx.$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0, row_r26.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", row_r26.id, " ");
  }
}
function VesselRevisionChangesModalComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r27 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r27.createdById, "User")), " ");
  }
}
function VesselRevisionChangesModalComponent_ng_template_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r28 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r28.sourceId, "SourceSystem")), " ");
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 39);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 175)("title", i0.ɵɵpipeBind1(1, 2, "Vessel Name"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 40);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "GRT"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 41);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "NRT"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 42);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "LOA"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_26_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 44);
  }
  if (rf & 2) {
    const row_r30 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r30.countryId)("floating", true);
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 43);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, VesselRevisionChangesModalComponent_kendo_grid_column_26_ng_template_2_Template, 1, 2, "ng-template", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 200)("title", i0.ɵɵpipeBind1(1, 2, "Flag"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 45);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "IMO Number"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 46);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "IMO Company Number"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 47);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "MMSI"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 48);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Call Sign"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 49);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Deadweight Tonnage"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 50);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Height"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 51);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Registered Length"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 52);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Length Between Perpendiculars"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 53);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Draft"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 54);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Breadth Extreme"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 55);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Breadth Moulded"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 56);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Depth"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-column", 57);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Year Build"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_40_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-bool", 59);
  }
  if (rf & 2) {
    const row_r32 = ctx.$implicit;
    i0.ɵɵproperty("value", row_r32.wasteExemption);
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 58);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, VesselRevisionChangesModalComponent_kendo_grid_column_40_ng_template_2_Template, 1, 1, "ng-template", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Waste Exemption"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_41_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r34 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r34.typeId, "VesselType")), " ");
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_41_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 60);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, VesselRevisionChangesModalComponent_kendo_grid_column_41_ng_template_2_Template, 3, 6, "ng-template", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 200)("title", i0.ɵɵpipeBind1(1, 2, "Vessel Type"));
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_42_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r36 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r36.statusId, "VesselStatus")), " ");
  }
}
function VesselRevisionChangesModalComponent_kendo_grid_column_42_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 61);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, VesselRevisionChangesModalComponent_kendo_grid_column_42_ng_template_2_Template, 3, 6, "ng-template", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(1, 2, "Status"));
  }
}
export class VesselRevisionChangesModalComponent {
  constructor(activeModal, breezeService, dialogService) {
    this.activeModal = activeModal;
    this.breezeService = breezeService;
    this.dialogService = dialogService;
    this.gridData = [];
    this.ignoredDifferentColumns = ['id', 'createdById', 'createdDate', 'sourceId'];
    this.differentColumns = [];
    this.gridSort = [{
      field: 'createdDate',
      dir: 'desc'
    }];
  }
  ngOnInit() {
    this.vesselRevisions.current = this.breezeService.convertToDto(this.vesselRevisions.current);
    this.vesselRevisions.revised = this.breezeService.convertToDto(this.vesselRevisions.revised);
    let filteredVesselRevisions = {
      current: {},
      revised: {}
    };
    for (let [key] of Object.entries(this.vesselRevisions.revised)) {
      if (this.vesselRevisions.revised[key] !== this.vesselRevisions.current[key] || this.ignoredDifferentColumns.includes(key)) {
        filteredVesselRevisions.current[key] = this.vesselRevisions.current[key];
        filteredVesselRevisions.revised[key] = this.vesselRevisions.revised[key];
        this.differentColumns.push(key);
      }
    }
    this.gridData.push({
      label: 'Current',
      ...filteredVesselRevisions.current
    });
    this.gridData.push({
      label: 'Revised',
      ...filteredVesselRevisions.revised
    });
  }
  confirm() {
    this.dialogService.confirm('Confirm', 'Updating the Vessel details can have an impact on new Charge Candidates. Are you sure you wish to proceed?', false, 'Cancel', 'Proceed').then(result => {
      console.log(this.vesselRevisions.revised);
      if (result) this.close(this.vesselRevisions.revised.id);
    });
  }
  close(result = false) {
    this.activeModal.close(result);
  }
}
VesselRevisionChangesModalComponent.ɵfac = function VesselRevisionChangesModalComponent_Factory(t) {
  return new (t || VesselRevisionChangesModalComponent)(i0.ɵɵdirectiveInject(i1.NgbActiveModal), i0.ɵɵdirectiveInject(i2.BreezeService), i0.ɵɵdirectiveInject(i3.DialogService));
};
VesselRevisionChangesModalComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: VesselRevisionChangesModalComponent,
  selectors: [["app-vessel-revision-changes-modal"]],
  inputs: {
    vesselRevisions: "vesselRevisions"
  },
  decls: 50,
  vars: 46,
  consts: [[1, "modal-header"], [1, "modal-title"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [1, "mt-2", "mb-2", 3, "sort", "sortable", "data", "pageable", "scrollable"], ["field", "", 3, "width", "title"], ["kendoGridCellTemplate", ""], ["field", "id", 3, "width", "title"], ["field", "createdById", 3, "width", "title"], ["field", "createdDate", "format", "g", 3, "width", "title"], ["field", "sourceId", 3, "width", "title"], ["field", "name", "pattern", "[\\w\\d\\s\\.\\-\\']", 3, "width", "title", 4, "ngIf"], ["field", "grossTonnage", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "netTonnage", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "length", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "countryId", 3, "width", "title", 4, "ngIf"], ["field", "iMONumber", 3, "width", "title", 4, "ngIf"], ["field", "iMOCompanyNumber", 3, "width", "title", 4, "ngIf"], ["field", "mmsi", 3, "width", "title", 4, "ngIf"], ["field", "callsign", 3, "width", "title", 4, "ngIf"], ["field", "deadWeight", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "height", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "registeredLength", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "lengthBetweenPerpendiculars", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "draft", 3, "width", "title", 4, "ngIf"], ["field", "breadthExtreme", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "breadthMoulded", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "depth", "format", "n3", 3, "width", "title", 4, "ngIf"], ["field", "yearBuild", 3, "width", "title", 4, "ngIf"], ["field", "wasteExemption", 3, "width", "title", 4, "ngIf"], ["field", "typeId", 3, "width", "title", 4, "ngIf"], ["field", "statusId", 3, "width", "title", 4, "ngIf"], [1, "modal-footer"], [1, "mr-4"], ["kendoButton", "", "translate", "", 3, "click"], ["kendoButton", "", "primary", "true", "translate", "", 3, "click"], ["target", "_blank", 1, "text-primary", "link-box", 3, "routerLink"], ["icon", "arrow-up-right-from-square"], ["field", "name", "pattern", "[\\w\\d\\s\\.\\-\\']", 3, "width", "title"], ["field", "grossTonnage", "format", "n3", 3, "width", "title"], ["field", "netTonnage", "format", "n3", 3, "width", "title"], ["field", "length", "format", "n3", 3, "width", "title"], ["field", "countryId", 3, "width", "title"], ["codelist", "Country", 3, "code", "floating"], ["field", "iMONumber", 3, "width", "title"], ["field", "iMOCompanyNumber", 3, "width", "title"], ["field", "mmsi", 3, "width", "title"], ["field", "callsign", 3, "width", "title"], ["field", "deadWeight", "format", "n3", 3, "width", "title"], ["field", "height", "format", "n3", 3, "width", "title"], ["field", "registeredLength", "format", "n3", 3, "width", "title"], ["field", "lengthBetweenPerpendiculars", "format", "n3", 3, "width", "title"], ["field", "draft", 3, "width", "title"], ["field", "breadthExtreme", "format", "n3", 3, "width", "title"], ["field", "breadthMoulded", "format", "n3", 3, "width", "title"], ["field", "depth", "format", "n3", 3, "width", "title"], ["field", "yearBuild", 3, "width", "title"], ["field", "wasteExemption", 3, "width", "title"], [3, "value"], ["field", "typeId", 3, "width", "title"], ["field", "statusId", 3, "width", "title"]],
  template: function VesselRevisionChangesModalComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0)(1, "h5", 1);
      i0.ɵɵtext(2);
      i0.ɵɵpipe(3, "translate");
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(4, "button", 2);
      i0.ɵɵlistener("click", function VesselRevisionChangesModalComponent_Template_button_click_4_listener() {
        return ctx.close();
      });
      i0.ɵɵelementStart(5, "span", 3);
      i0.ɵɵtext(6, "\u00D7");
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(7, "div", 4)(8, "app-grid", 5)(9, "kendo-grid-column", 6);
      i0.ɵɵtemplate(10, VesselRevisionChangesModalComponent_ng_template_10_Template, 1, 1, "ng-template", 7);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(11, "kendo-grid-column", 8);
      i0.ɵɵpipe(12, "translate");
      i0.ɵɵtemplate(13, VesselRevisionChangesModalComponent_ng_template_13_Template, 3, 4, "ng-template", 7);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(14, "kendo-grid-column", 9);
      i0.ɵɵpipe(15, "translate");
      i0.ɵɵtemplate(16, VesselRevisionChangesModalComponent_ng_template_16_Template, 3, 6, "ng-template", 7);
      i0.ɵɵelementEnd();
      i0.ɵɵelement(17, "kendo-grid-column", 10);
      i0.ɵɵpipe(18, "translate");
      i0.ɵɵelementStart(19, "kendo-grid-column", 11);
      i0.ɵɵpipe(20, "translate");
      i0.ɵɵtemplate(21, VesselRevisionChangesModalComponent_ng_template_21_Template, 3, 6, "ng-template", 7);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(22, VesselRevisionChangesModalComponent_kendo_grid_column_22_Template, 2, 4, "kendo-grid-column", 12);
      i0.ɵɵtemplate(23, VesselRevisionChangesModalComponent_kendo_grid_column_23_Template, 2, 4, "kendo-grid-column", 13);
      i0.ɵɵtemplate(24, VesselRevisionChangesModalComponent_kendo_grid_column_24_Template, 2, 4, "kendo-grid-column", 14);
      i0.ɵɵtemplate(25, VesselRevisionChangesModalComponent_kendo_grid_column_25_Template, 2, 4, "kendo-grid-column", 15);
      i0.ɵɵtemplate(26, VesselRevisionChangesModalComponent_kendo_grid_column_26_Template, 3, 4, "kendo-grid-column", 16);
      i0.ɵɵtemplate(27, VesselRevisionChangesModalComponent_kendo_grid_column_27_Template, 2, 4, "kendo-grid-column", 17);
      i0.ɵɵtemplate(28, VesselRevisionChangesModalComponent_kendo_grid_column_28_Template, 2, 4, "kendo-grid-column", 18);
      i0.ɵɵtemplate(29, VesselRevisionChangesModalComponent_kendo_grid_column_29_Template, 2, 4, "kendo-grid-column", 19);
      i0.ɵɵtemplate(30, VesselRevisionChangesModalComponent_kendo_grid_column_30_Template, 2, 4, "kendo-grid-column", 20);
      i0.ɵɵtemplate(31, VesselRevisionChangesModalComponent_kendo_grid_column_31_Template, 2, 4, "kendo-grid-column", 21);
      i0.ɵɵtemplate(32, VesselRevisionChangesModalComponent_kendo_grid_column_32_Template, 2, 4, "kendo-grid-column", 22);
      i0.ɵɵtemplate(33, VesselRevisionChangesModalComponent_kendo_grid_column_33_Template, 2, 4, "kendo-grid-column", 23);
      i0.ɵɵtemplate(34, VesselRevisionChangesModalComponent_kendo_grid_column_34_Template, 2, 4, "kendo-grid-column", 24);
      i0.ɵɵtemplate(35, VesselRevisionChangesModalComponent_kendo_grid_column_35_Template, 2, 4, "kendo-grid-column", 25);
      i0.ɵɵtemplate(36, VesselRevisionChangesModalComponent_kendo_grid_column_36_Template, 2, 4, "kendo-grid-column", 26);
      i0.ɵɵtemplate(37, VesselRevisionChangesModalComponent_kendo_grid_column_37_Template, 2, 4, "kendo-grid-column", 27);
      i0.ɵɵtemplate(38, VesselRevisionChangesModalComponent_kendo_grid_column_38_Template, 2, 4, "kendo-grid-column", 28);
      i0.ɵɵtemplate(39, VesselRevisionChangesModalComponent_kendo_grid_column_39_Template, 2, 4, "kendo-grid-column", 29);
      i0.ɵɵtemplate(40, VesselRevisionChangesModalComponent_kendo_grid_column_40_Template, 3, 4, "kendo-grid-column", 30);
      i0.ɵɵtemplate(41, VesselRevisionChangesModalComponent_kendo_grid_column_41_Template, 3, 4, "kendo-grid-column", 31);
      i0.ɵɵtemplate(42, VesselRevisionChangesModalComponent_kendo_grid_column_42_Template, 3, 4, "kendo-grid-column", 32);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(43, "div", 33)(44, "div", 34);
      i0.ɵɵtext(45, "Confirm and apply changes?");
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(46, "button", 35);
      i0.ɵɵlistener("click", function VesselRevisionChangesModalComponent_Template_button_click_46_listener() {
        return ctx.close();
      });
      i0.ɵɵtext(47, "Cancel");
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(48, "button", 36);
      i0.ɵɵlistener("click", function VesselRevisionChangesModalComponent_Template_button_click_48_listener() {
        return ctx.confirm();
      });
      i0.ɵɵtext(49, "Ok");
      i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 36, "Vessel Details update"));
      i0.ɵɵadvance(6);
      i0.ɵɵproperty("sort", ctx.gridSort)("sortable", false)("data", ctx.gridData)("pageable", false)("scrollable", "scrollable");
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("width", 100);
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(12, 38, "Revision Id"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("width", 175)("title", i0.ɵɵpipeBind1(15, 40, "Created By"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("width", 150)("title", i0.ɵɵpipeBind1(18, 42, "Created Date"));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(20, 44, "Source"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("name"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("grossTonnage"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("netTonnage"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("length"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("countryId"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("iMONumber"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("iMOCompanyNumber"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("mmsi"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("callsign"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("deadWeight"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("height"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("registeredLength"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("lengthBetweenPerpendiculars"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("draft"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("breadthExtreme"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("breadthMoulded"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("depth"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("yearBuild"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("wasteExemption"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("typeId"));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.differentColumns.includes("statusId"));
    }
  },
  dependencies: [i4.NgIf, i5.RouterLink, i6.FaIconComponent, i7.TranslateDirective, i8.ColumnComponent, i8.CellTemplateDirective, i9.Button, i10.AppGridComponent, i11.BoolComponent, i12.FlagIconComponent, i4.AsyncPipe, i7.TranslatePipe, i13.CodelistPipe],
  styles: [".k-grid-content[_ngcontent-%COMP%] {\n  overflow-x: scroll;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9hcHAvY29tbW9uL2NvbXBvbmVudHMvdmVzc2VsLXJldmlzaW9uLWNoYW5nZXMtbW9kYWwvdmVzc2VsLXJldmlzaW9uLWNoYW5nZXMtbW9kYWwuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxrQkFBQTtBQUNKIiwic291cmNlc0NvbnRlbnQiOlsiLmstZ3JpZC1jb250ZW50IHtcclxuICAgIG92ZXJmbG93LXg6IHNjcm9sbDtcclxufVxyXG4iXSwic291cmNlUm9vdCI6IiJ9 */"]
});